import { useMemo } from 'react'

export const ProgramImage = ({
  title,
  callLetter,
  friendlyUrlName,
  startDate,
  endDate,
  titleId,
  availableOnMeoGo,
}: {
  title: string
  callLetter: string
  startDate: Date
  endDate: Date
  programId: string | number
  titleId: string
  friendlyUrlName: string
  availableOnMeoGo: boolean
}) => {
  const now = new Date()
  const isCurrent = now >= startDate && now <= endDate
  const isPast = now > endDate
  const percentElapsed =
    ((now.getTime() - startDate.getTime()) /
      (endDate.getTime() - startDate.getTime())) *
    100
  const imageSource = useMemo(
    () =>
      `https://cdn-er-images.online.meo.pt/eemstb/ImageHandler.ashx?progTitle=${title}&chCallLetter=${callLetter}&profile=16_9&appSource=GuiaTV&width=300&stb=retina2x`,
    [title, callLetter]
  )
  const baseURL = import.meta.env.VITE_MEOGO_BASE_URL

  const linkToShow = useMemo(
    () =>
      isPast
        ? `${baseURL}/info/tv?callLetter=${callLetter}&titleId=${titleId}` //todo detalhe, falta start date and episode numebr
        : `${baseURL}/player?channel=${friendlyUrlName}`, //done - direto rlName
    [isPast, titleId, callLetter, friendlyUrlName, baseURL]
  )
  const Wrapper = (isPast || isCurrent) && availableOnMeoGo ? 'a' : 'div'
  return (
    <Wrapper
      href={availableOnMeoGo && (isPast || isCurrent) ? linkToShow : undefined}
      target="_blank"
    >
      <div
        className="image-container"
        style={{
          cursor:
            availableOnMeoGo && (isPast || isCurrent) ? 'pointer' : 'default',
        }}
      >
        <img src={imageSource} className="channel-image" />
        <div className="channel-overlay"></div>
        {(isPast || isCurrent) && availableOnMeoGo && (
          <span className="channel-play-icon icon-play"></span>
        )}

        {isCurrent && (
          <div className="program-progress">
            <div
              className="program-progress-bar"
              style={{ width: `${percentElapsed}%` }}
            />
          </div>
        )}
      </div>
    </Wrapper>
  )
}
